module.exports = __webpack_public_path__ + "static/img/mianqianfengzhuang.14d8beb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mianqianfengzhuang.png
// module id = UWKw
// module chunks = 1